import { Grid, Tag, Text } from '@wework/dieter-ui'

import React from 'react'
import { useSidebar } from '../../hoc/withSidebar'

export const getDeskLinkeageStatus = (space, noText = false) => {
  if (space?.reservable) {
    return (
      <>
        {!noText ? (
          <Text style={{ fontSize: 14, lineHeight: '24px' }}>
            Select desk inventory item to link to this physical object so the
            map shows the right inventory.
          </Text>
        ) : null}
        <Tag color="green" size="small">
          LINKED
        </Tag>
      </>
    )
  } else {
    return (
      <>
        {!noText ? (
          <Text style={{ fontSize: 14, lineHeight: '24px' }}>
            Select desk inventory item to link to this physical object so the
            map shows the right inventory.
          </Text>
        ) : null}
        <Tag color="red" size="small">
          NOT LINKED
        </Tag>
      </>
    )
  }
}

export default function LinkDesk({ space }) {
  const { openSideBar } = useSidebar()
  return (
    <Grid.Row>
      <Grid.Column width={8}>
        <Text style={{ fontSize: 16, fontWeight: 'bold' }}>
          Link desk inventory
        </Text>

        {getDeskLinkeageStatus(space)}
      </Grid.Column>
      <Grid.Column
        width={8}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Text
          style={{ fontSize: 14, cursor: 'pointer' }}
          primary
          onClick={() => openSideBar('DeskLinkeage')}
        >
          Update{' >'}
        </Text>
      </Grid.Column>
    </Grid.Row>
  )
}
